const toTrimmedLower = (value) => String(value || "").trim().toLowerCase();

export const getBookingRecordId = (booking = {}, fallback = "") =>
  String(
    booking?.booking_id ||
      booking?.bookingId ||
      booking?.id ||
      fallback
  ).trim();

export const getBookingStatusValue = (booking = {}) =>
  toTrimmedLower(booking?.status);

export const getBookingPaymentStatusValue = (booking = {}) =>
  toTrimmedLower(booking?.payment_status);

export const getBookingPaymentAttemptStatusValue = (booking = {}) =>
  toTrimmedLower(
    booking?.paymentAttemptStatus || booking?.payment_attempt_status
  );

export const isPendingBooking = (booking = {}) => {
  const status = getBookingStatusValue(booking);
  const paymentStatus = getBookingPaymentStatusValue(booking);
  const paymentAttemptStatus = getBookingPaymentAttemptStatusValue(booking);

  return (
    status === "pending" ||
    paymentStatus === "pending" ||
    paymentAttemptStatus === "checkout_started" ||
    paymentAttemptStatus === "failed_or_cancelled"
  );
};

export const repartitionBookings = ({
  upcoming = [],
  past = [],
} = {}) => {
  const nextPending = [];
  const nextUpcoming = [];
  const nextPast = [];
  const seenIds = new Set();

  const appendBooking = (booking, defaultBucket, index) => {
    const bookingId = getBookingRecordId(booking, `${defaultBucket}-${index}`);
    if (seenIds.has(bookingId)) return;
    seenIds.add(bookingId);

    if (isPendingBooking(booking)) {
      nextPending.push(booking);
      return;
    }

    if (defaultBucket === "upcoming" || booking?.is_upcoming) {
      nextUpcoming.push(booking);
      return;
    }

    nextPast.push(booking);
  };

  (Array.isArray(upcoming) ? upcoming : []).forEach((booking, index) =>
    appendBooking(booking, "upcoming", index)
  );
  (Array.isArray(past) ? past : []).forEach((booking, index) =>
    appendBooking(booking, "past", index)
  );

  return {
    pending: nextPending,
    upcoming: nextUpcoming,
    past: nextPast,
    summary: {
      pending: nextPending.length,
      upcoming: nextUpcoming.length,
      past: nextPast.length,
      total: nextPending.length + nextUpcoming.length + nextPast.length,
    },
  };
};

export const getStudentBookingDisplayStatus = (booking = {}) => {
  if (isPendingBooking(booking)) {
    return "Pending";
  }

  return booking?.is_upcoming ? "Upcoming" : "Completed";
};

export const getTeacherBookingDisplayStatus = (booking = {}) => {
  if (isPendingBooking(booking)) {
    return "Pending";
  }

  const status = getBookingStatusValue(booking);
  if (!status) return "Upcoming";

  return status.charAt(0).toUpperCase() + status.slice(1);
};
